/**
 * Created by Sravanth on 06-11-2020.
 */
export class TutorialsPortraitProps {
  public static get hy(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 396,
      TN_pays_blank_position_17_Top: 396,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 70,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 10,
      percentageContentTop: 25,
    };
  }

  public static get 'zh-Hans'(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get 'zh-Hant'(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get cs(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 25,
    };
  }

  public static get da(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 390,
      TN_pays_blank_position_17_Top_pays_blank_small: 390,
      TN_pays_blank_position_16_Top: 386,
      TN_pays_blank_position_17_Top: 386,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 25,
    };
  }

  public static get nl(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 390,
      TN_pays_blank_position_17_Top_pays_blank_small: 390,
      TN_pays_blank_position_16_Top: 383,
      TN_pays_blank_position_17_Top: 383,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 15,
      percentageContentTop: 27,
    };
  }

  public static get en(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 398,
      TN_pays_blank_position_17_Top: 398,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get fi(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 72,
      TN_pays_blank_position_17_Left: 72,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 25,
    };
  }

  public static get fr(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 68,
      TN_pays_blank_position_17_Left: 68,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get de(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 26,
    };
  }

  public static get he(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 424,
      TN_pays_blank_position_17_Top_pays_blank_small: 424,
      TN_pays_blank_position_16_Top: 420,
      TN_pays_blank_position_17_Top: 420,
      TN_pays_blank_position_16_Left: 525,
      TN_pays_blank_position_17_Left: 525,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 9,
      percentageContentTop: 24,
    };
  }

  public static get id(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 398,
      TN_pays_blank_position_17_Top: 398,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 9,
      percentageContentTop: 26,
    };
  }

  public static get it(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 9,
      percentageContentTop: 27,
    };
  }

  public static get ja(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 402,
      TN_pays_blank_position_17_Top_pays_blank_small: 402,
      TN_pays_blank_position_16_Top: 398,
      TN_pays_blank_position_17_Top: 398,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get ko(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 398,
      TN_pays_blank_position_17_Top: 398,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get nb(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 26,
    };
  }

  public static get pl(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 26,
    };
  }

  public static get 'pt-BR'(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 398,
      TN_pays_blank_position_17_Top: 398,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get ru(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 397,
      TN_pays_blank_position_17_Top: 397,
      TN_pays_blank_position_16_Left: 65,
      TN_pays_blank_position_17_Left: 78,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 15,
      percentageContentTop: 27,
    };
  }

  public static get es(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 406,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 401,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 68,
      TN_pays_blank_position_17_Left: 70,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get sv(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 385,
      TN_pays_blank_position_17_Top_pays_blank_small: 385,
      TN_pays_blank_position_16_Top: 381,
      TN_pays_blank_position_17_Top: 381,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get th(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 385,
      TN_pays_blank_position_17_Top_pays_blank_small: 385,
      TN_pays_blank_position_16_Top: 382,
      TN_pays_blank_position_17_Top: 382,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 6,
      percentageContentTop: 24,
    };
  }

  public static get tr(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 398,
      TN_pays_blank_position_17_Top: 398,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get vi(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 395,
      TN_pays_blank_position_17_Top_pays_blank_small: 395,
      TN_pays_blank_position_16_Top: 392,
      TN_pays_blank_position_17_Top: 392,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 13,
      percentageContentTop: 27,
    };
  }

  public static get ar(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 424,
      TN_pays_blank_position_17_Top_pays_blank_small: 424,
      TN_pays_blank_position_16_Top: 418,
      TN_pays_blank_position_17_Top: 418,
      TN_pays_blank_position_16_Left: 525,
      TN_pays_blank_position_17_Left: 525,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 9,
      percentageContentTop: 25,
    };
  }

  public static get bg(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 10.5,
      percentageContentTop: 26.5,
    };
  }

  public static get ee(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 426,
      TN_pays_blank_position_17_Top_pays_blank_small: 426,
      TN_pays_blank_position_16_Top: 423,
      TN_pays_blank_position_17_Top: 423,
      TN_pays_blank_position_16_Left: 63,
      TN_pays_blank_position_17_Left: 63,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 12,
      percentageContentTop: 26,
    };
  }

  public static get ge(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 390,
      TN_pays_blank_position_16_Top: 398,
      TN_pays_blank_position_17_Top: 388,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 26,
    };
  }

  public static get gr(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get 'hi-IN'(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 385,
      TN_pays_blank_position_17_Top_pays_blank_small: 385,
      TN_pays_blank_position_16_Top: 381,
      TN_pays_blank_position_17_Top: 381,
      TN_pays_blank_position_16_Left: 65,
      TN_pays_blank_position_17_Left: 65,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get hu(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 385,
      TN_pays_blank_position_17_Top_pays_blank_small: 385,
      TN_pays_blank_position_16_Top: 381,
      TN_pays_blank_position_17_Top: 381,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 13,
      percentageContentTop: 26,
    };
  }

  public static get lt(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 62,
      TN_pays_blank_position_17_Left: 62,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 8,
      percentageContentTop: 25,
    };
  }

  public static get kh(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 381,
      TN_pays_blank_position_17_Top_pays_blank_small: 381,
      TN_pays_blank_position_16_Top: 376,
      TN_pays_blank_position_17_Top: 376,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 14,
      percentageContentTop: 26,
    };
  }

  public static get lv(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 398,
      TN_pays_blank_position_17_Top: 398,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 10,
      percentageContentTop: 25,
    };
  }

  public static get mt(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 396,
      TN_pays_blank_position_17_Top: 396,
      TN_pays_blank_position_16_Left: 69,
      TN_pays_blank_position_17_Left: 69,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 7,
      percentageContentTop: 24,
    };
  }

  public static get my(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 397,
      TN_pays_blank_position_17_Top: 397,
      TN_pays_blank_position_16_Left: 71,
      TN_pays_blank_position_17_Left: 71,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get ph(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 385,
      TN_pays_blank_position_17_Top_pays_blank_small: 385,
      TN_pays_blank_position_16_Top: 381,
      TN_pays_blank_position_17_Top: 381,
      TN_pays_blank_position_16_Left: 79,
      TN_pays_blank_position_17_Left: 79,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 26,
    };
  }

  public static get ro(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 391,
      TN_pays_blank_position_17_Top_pays_blank_small: 391,
      TN_pays_blank_position_16_Top: 384,
      TN_pays_blank_position_17_Top: 384,
      TN_pays_blank_position_16_Left: 71,
      TN_pays_blank_position_17_Left: 71,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get si(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 405,
      TN_pays_blank_position_17_Top_pays_blank_small: 405,
      TN_pays_blank_position_16_Top: 400,
      TN_pays_blank_position_17_Top: 400,
      TN_pays_blank_position_16_Left: 69,
      TN_pays_blank_position_17_Left: 69,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 11,
      percentageContentTop: 27,
    };
  }

  public static get sk(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 409,
      TN_pays_blank_position_17_Top_pays_blank_small: 409,
      TN_pays_blank_position_16_Top: 403,
      TN_pays_blank_position_17_Top: 403,
      TN_pays_blank_position_16_Left: 73,
      TN_pays_blank_position_17_Left: 73,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 10,
      percentageContentTop: 26,
    };
  }

  public static get 'sr-RS'(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 401,
      TN_pays_blank_position_17_Top_pays_blank_small: 401,
      TN_pays_blank_position_16_Top: 397,
      TN_pays_blank_position_17_Top: 397,
      TN_pays_blank_position_16_Left: 67,
      TN_pays_blank_position_17_Left: 67,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 9,
      percentageContentTop: 25,
    };
  }

  public static get 'ta-IN'(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 399,
      TN_pays_blank_position_17_Top: 399,
      TN_pays_blank_position_16_Left: 61,
      TN_pays_blank_position_17_Left: 61,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 13,
      percentageContentTop: 26,
    };
  }

  public static get ua(): translateFontProp {
    return {
      TN_pays_blank_position_16_Top_pays_blank_small: 403,
      TN_pays_blank_position_17_Top_pays_blank_small: 403,
      TN_pays_blank_position_16_Top: 397,
      TN_pays_blank_position_17_Top: 397,
      TN_pays_blank_position_16_Left: 63,
      TN_pays_blank_position_17_Left: 63,
      splitCard_13_top: 246,
      tnimage_split_height: 526,
      paysContentTop: 10,
      percentageContentTop: 26,
    };
  }
}

interface translateFontProp {
  TN_pays_blank_position_16_Top_pays_blank_small: number;
  TN_pays_blank_position_17_Top_pays_blank_small: number;
  TN_pays_blank_position_16_Top: number;
  TN_pays_blank_position_17_Top: number;
  TN_pays_blank_position_16_Left: number;
  TN_pays_blank_position_17_Left: number;
  splitCard_13_top: number;
  tnimage_split_height: number;
  paysContentTop: number;
  percentageContentTop: number;
}
